<template>
  <div style="">

    <el-form ref="form" :model="submit_data" label-width="80px"
      style="overflow-y: auto; height: 85vh; margin-top: 20px;">

      <el-form-item label="司机编码:" label-width='120px'>
        <el-input v-model="submit_data.driver_code" :placeholder="submit_rules.driver_code.placeholder"
          style="width: 80%;" disabled>
        </el-input>
      </el-form-item>

      <el-form-item label="司机名称:" label-width='120px'>
        <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 80%;">
        </el-input>
      </el-form-item>

      <el-form-item label="司机标记:" label-width='120px' v-if="activite_sum_show">
        <el-input v-model="submit_data.activite_sum"  style="width: 80%;">
        </el-input>
      </el-form-item>

      <el-form-item label="手机号码:" label-width='120px'>
        <el-input v-model="submit_data.phone" :placeholder="submit_rules.phone.placeholder" maxlength='11'
          style="width: 80%;">
        </el-input>
      </el-form-item>

      <el-form-item label="家庭住址:" label-width='120px'>
        <el-input v-model="submit_data.address" :placeholder="submit_rules.address.placeholder" style="width: 80%;">
        </el-input>
      </el-form-item>

      <el-form-item label="司机钱包:" label-width='120px'>
        <!-- <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 120px; text-align: right; margin-right: 10px;">押金:</span>

          <span style="color: rgb(233, 161, 6);">{{ form.bond }}</span>
           元
        </p>
        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 120px; text-align: right; margin-right: 10px;">余额:</span>
          <span style="color: rgb(233, 161, 6);">{{ form.balance }}</span>
          元
          <span style="font-size: 14px;display: inline-block;margin: 0 5px" :style="{color:form.is_freeze=='0'?'#05C0AB':'#FF7171'}">{{form.is_freeze=='0'?'(正常)':'(冻结中)'}}</span>
          <el-button v-if="form.is_freeze=='0'" @click="frozen('1')">冻结账户</el-button>
          <el-button v-if="form.is_freeze=='1'" @click="frozen('0')">解冻</el-button>
        </p>
        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 120px; text-align: right; margin-right: 10px;">已提现:</span>
          <span style="color: rgb(233, 161, 6);">{{ form.cash }}</span>
           元
        </p>
        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 120px; text-align: right; margin-right: 10px;">已冻结:</span>
          <span style="color: rgb(233, 161, 6);">{{ form.frozen }}</span>
           元
        </p> -->

        <p style="margin: 10px 0;">
          <span style="display: inline-block; width: 120px; text-align: right; margin-right: 10px;">服务费:</span>
          <span style="color: rgb(233, 161, 6);">{{ form.insurance }}</span>
           元
        </p>
      </el-form-item>



      <el-form-item label="性别:" label-width='120px'>
        <el-radio v-model="submit_data.sex" :label="String(item.val)" v-for="(item, index) in sex_select" :key="index">
          {{ item.alias }}</el-radio>
      </el-form-item>

      <el-form-item label="工作类型:" label-width='120px'>
        <el-radio v-model="submit_data.driver_or_legwork" label="0">
          代驾司机</el-radio>
        <el-radio v-model="submit_data.driver_or_legwork" label="1">
          跑腿骑手</el-radio>
      </el-form-item>

      <el-form-item label="等级:" label-width='120px' v-if="admin_name">
        <el-input v-model="submit_data.level" :placeholder="submit_rules.level.placeholder" style="width: 20%;">
        </el-input>
      </el-form-item>

      <el-form-item label="管理状态:" label-width='120px'>
        <el-radio v-model="submit_data.status" :label="String(item.val)" v-for="(item, index) in status_select"
          :key="index">{{ item.alias }}</el-radio>
      </el-form-item>


      <el-form-item label="职位:" label-width='120px'>
        <el-radio v-model="submit_data.capacity" :label="String(item.val)" v-for="(item, index) in capacity"
          :key="index">{{ item.alias }}</el-radio>
      </el-form-item>


      <el-form-item label="城市小组:" label-width='120px'>
        <el-select v-model="teamChange_name" placeholder="请选择城市" style="width: 150px; margin-right: 20px;"
          @change="teamChange" @visible-change="getTeamSelect" clearable>
          <el-option v-for="item in team_select" :label="item.name" :value="item.city_group.city_group_code">
          </el-option>
        </el-select>
        <!-- <el-input v-model="submit_data.city_group" style="width: 80%;"></el-input> -->
        <!-- <el-radio v-model="submit_data.city_group" :label="String(item.val)" v-for="(item, index) in capacity"
          :key="index">{{ item.alias }}</el-radio> -->
      </el-form-item>


      <el-form-item label="紧急联系人:" label-width='120px'>
        <el-input v-model="submit_data.urgent_name" :placeholder="submit_rules.urgent_name.placeholder"
          style="width: 80%;"></el-input>
      </el-form-item>

      <el-form-item label="紧急联系人电话:" label-width='120px'>
        <el-input v-model="submit_data.urgent_phone" :placeholder="submit_rules.urgent_phone.placeholder" maxlength='11'
          style="width: 80%;"></el-input>
      </el-form-item>

      <el-form-item label="头像:" label-width='120px'>

        <!-- <el-input v-model="submit_data.logo_img_url" style="width: 80%;"></el-input> -->
        <el-image :preview-src-list="srcList" v-if="img_url.logo_img_url" :src="img_url.logo_img_url" class="avatar">
        </el-image>
        <el-upload :class="img_url.logo_img_url?'border-none':''" class="avatar-uploader" :action="img_upload_url"
          :show-file-list="false" :on-success="idPortraitSuccess" :before-upload="beforeAvatarUpload"
          :headers="img_headers">
          <el-button slot="trigger" v-if="img_url.logo_img_url" @click="img_url.logo_img_url='';"
            style="width: 100px; margin-top: 10px;">更换图片</el-button>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>


      </el-form-item>

      <el-form-item label="备注:" label-width='120px'>
        <el-input type="textarea" v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder"
          style="width: 80%;">
        </el-input>
      </el-form-item>

      <el-form-item label="系统备注:" label-width='120px'>
        <el-input type="textarea" v-model="submit_data.system_remarks"
          :placeholder="submit_rules.system_remarks.placeholder" style="width: 80%;"></el-input>
      </el-form-item>


    </el-form>

    <div style="display: flex;justify-content: center">
      <el-button type="primary" @click="beforeSubmit">保存</el-button>
      <el-button @click="closeDialog">关闭</el-button>
    </div>

    <el-dialog
        :title="frozen_type=='1'?'请选择冻结原因':'解除余额冻结？'"
        :visible="frozen_isShow"
        append-to-body
        :show-close="false"
        center
        width="30%">

      <el-radio-group v-model="frozen_radio"  v-if="frozen_type=='1'">
        <el-radio :label="item.label" v-for="item in frozen_array" style="display: block;margin: 10px 0"></el-radio>
      </el-radio-group>

      <span slot="footer" class="dialog-footer" v-if="frozen_type=='1'">
         <el-button type="primary" @click="frozenSubmit">保存</el-button>
        <el-button @click="frozen_isShow = false">关闭</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-if="frozen_type=='0'">
         <el-button type="primary" @click="frozenSubmit">解冻</el-button>
        <el-button @click="frozen_isShow = false">关闭</el-button>
      </span>
    </el-dialog>



  </div>



</template>

<script>
  var _this;
  import bus from '../../common/bus.js';
  import {
    config
  } from '../../../utils/config'; // 配置
  import axios from 'axios'; // AJAX封装类
  export default {
    props: {
      'driverShow': Boolean,
      'data': ''
    },

    watch: {
      driverShow: {
        immediate: true,
        handler: function (newData, oldData) {

          // 清空城市下拉框内容


          // 获取上传图片的地址
          this.img_upload_url = config.axios_imgURL;

          console.log(newData);
          if (newData) {

            console.log(this,'============================');
            this.submit_data.driver_code = this.data;

            this.walletInit()


            this.labelLists()

            this.$post(
                "/driver/getDriverDetails", {
                  driver_code: this.data
                }
              )
              .then(res => {
                console.log(res.data);


                this.sex_select = res.data.sex.select_array;
                this.status_select = res.data.status.select_array;

                this.capacity = res.data.capacity.select_array



                if (res.data.logo_img.url != "未设置") {
                  this.img_url.logo_img_url = res.data.logo_img.url;
                }

                this.srcList.length = 0;
                this.srcList.push(this.img_url.logo_img_url)

                // 请求的数据对应存入到submit_data对象中
                this.submit_data.driver_code = res.data.driver_code;
                this.submit_data.name = res.data.name;
                this.submit_data.phone = res.data.phone;
                this.submit_data.address = res.data.address;
                this.submit_data.sex = res.data.sex.val;
                this.submit_data.level = res.data.level.lv;
                this.submit_data.activite_sum = res.data.activite_sum;

                this.submit_data.capacity = res.data.capacity.val
                // this.submit_data.city_group = res.data.city_group.name
                this.teamChange_name = res.data.city_group.name


                this.submit_data.status = res.data.status.val;
                this.submit_data.logo_img_hash = res.data.logo_img.hash;


                this.submit_data.urgent_name = res.data.urgent_name;
                this.submit_data.urgent_phone = res.data.urgent_phone;
                this.submit_data.remarks = res.data.remarks;
                this.submit_data.system_remarks = res.data.system_remarks;
                this.submit_data.driver_or_legwork = res.data.driver_or_legwork;

                console.log(this.submit_data.sex);


              })



          }



        }

      },
      value_city_code(newvalue, oldvalue) {
        console.log(newvalue, oldvalue)
        console.log(newvalue.slice(0, 4) == 'CITY')
        if (newvalue.slice(0, 4) == 'CITY') {
          this.$post(
              "/city/cityGroupLists", {
                'page': 1,
                'limit': 20,
                'name': '',
                'status': '1',
                'remarks': '',
              }
            )
            .then(res => {

              console.log(res);
              this.team_select = res.data;


            })
        } else if (newvalue == '未知') {
          this.team_select = ''
        }

      }
    },
    data() {
      return {
        admin_name:JSON.parse(localStorage.getItem('login')).admin_role_code == 'ROLE5F4755FD0D56447',//判断是否为总经理
        activite_sum_show:JSON.parse(localStorage.getItem('login')).driver_write_add == '1',

        srcList: [],

        sex_select: [],
        status_select: [],
        team_select: [], //城市小组
        capacity: [],


        //冻结原因标签
        frozen_array:[],
        frozen_radio:'',
        frozen_isShow:false,
        frozen_type:'1',

        form: {
          bond: '0.00',
          balance: '0.00',
          cash: '0.00',
          frozen: '0.00',
          insurance: '0.00',
          is_freeze:'0'
        },

        teamChange_name: '',
        //压缩质量
        imgQuality: 0.5,

        // 上传图片的请求头
        img_headers: {

          'token': '',
          'hash-key': '',
          'platform': 'pc',
          'app-version': 'admin',
          'port': 'admin',
          'city-tag':localStorage.getItem('city_tag')

        },

        // 图片上传地址
        img_upload_url: '',

        //上传图片
        img_url: {

          logo_img_url: '',

        },



        // 表单数据
        submit_data: {
          driver_code: '',
          name: '',
          phone: '',
          address: '',
          sex: '',
          status: '',
          level: '',
          urgent_name: '',
          urgent_phone: '',
          logo_img_hash: '',
          remarks: '',
          system_remarks: '',
          capacity: '',
          city_group_code: '',
          activite_sum:'',
          driver_or_legwork:''

        },

        submit_rules: {
          driver_code: {
            placeholder: '司机编码',
            rules: {
              required: true,
              message: '司机编码错误',
              regulation: 'special',
              rulesData: 'driver_code'
            }
          },
          name: {
            placeholder: '司机名称需在40字之内',
            rules: {
              required: false,
              message: '司机名称需在40字之内',
              regulation: 'elt_str',
              rulesData: 40
            }
          },
          phone: {
            placeholder: '手机号码必须为11位',
            rules: {
              required: false,
              message: '手机号码必须为11位',
              regulation: 'eq_str',
              rulesData: 11
            }
          },
          address: {
            placeholder: '请输入家庭住址',
            rules: {
              required: false,
              message: '家庭住址错误',
              regulation: 'elt_str',
              rulesData: 100
            }
          },
          level: {
            placeholder: '请输入等级',
            rules: {
              required: false,
              message: '等级1-10000',
              regulation: 'elt_str',
              rulesData: 5
            }
          },


          urgent_name: {
            placeholder: '紧急联系人 40字节以内',
            rules: {
              required: false,
              message: '紧急联系人 40字以内',
              regulation: 'elt_str',
              rulesData: 40
            }
          },
          urgent_phone: {
            placeholder: '紧急联系人手机号码必须为11位',
            rules: {
              required: false,
              message: '紧急联系人手机号码必须为11位',
              regulation: 'eq_num',
              rulesData: 11
            }
          },
          logo_img_hash: {
            placeholder: '头像',
            rules: {
              required: false,
              message: '头像错误',
              regulation: 'lt_str',
              rulesData: 'json_array'
            }
          },
          remarks: {
            placeholder: '备注，500字之内',
            rules: {
              required: false,
              message: '备注，500字之内',
              regulation: 'elt_str',
              rulesData: 500
            }
          },
          system_remarks: {
            placeholder: '系统备注，500字之内',
            rules: {
              required: false,
              message: '系统备注，500字之内',
              regulation: 'elt_str',
              rulesData: 500
            }
          },
        },

      };
    },
    created() {

      _this = this;


    },
    methods: {
      frozenSubmit(){

        if(_this.frozen_radio == '' && _this.frozen_type == 1){

          _this.$message.error('请选择冻结原因')

          return;

        }

        this.$post(
          '/driver/driverFreeze', {
            driver_code:_this.submit_data.driver_code,
            status:_this.frozen_type,
            remarks:_this.frozen_radio
          }
        ).then(res => {

          _this.frozen_isShow = false;
          _this.walletInit()
        }).catch((err) => {

        })

      },


      frozen(val){

        _this.frozen_isShow = true;

        _this.frozen_type = val;

      },


      labelLists(){

        this.$post(
                '/label/labelLists', {
                 status:''
                }
        ).then(res => {
            _this.frozen_array = res.data.driver.freeze_reason.label
        }).catch((err) => {

        })
      },


      walletInit(){

        this.$post(
                '/driver/getDriverWallet', {
                  driver_code: this.submit_data.driver_code
                }
        )
                .then(res => {
                  console.log(111);
                  // 将获取到的数据赋值
                  this.form.bond=res.data.bond;
                  this.form.balance=res.data.balance;
                  this.form.cash=res.data.cash;
                  this.form.frozen=res.data.frozen;
                  this.form.insurance=res.data.insurance;
                  this.form.is_freeze = res.data.is_freeze
                }).catch((err) => {

        })
      },

      getTeamSelect() {

        _this.$post(
            "/city/cityGroupLists", {
              'page': 1,
              'limit': 20,
              'name': '',
              'status': '1',
              'remarks': '',
            }
          )
          .then(res => {

            this.team_select = res.data;


          })

      },
      teamChange(e) {
        console.log(e)
        this.submit_data.city_group_code = e
      },
      // 身份证人像面上传成功后执行
      idPortraitSuccess(res, file) {

        // 将返回的哈希值存到对应的数组中
        // _this.id_card_portrait_arrway.push(res.data.img_hash);

        // 将返回的哈希值存到submit_data对象
        _this.submit_data.logo_img_hash = res.data.img_hash;

        // 设置img标签显示的图片路径
        _this.img_url.logo_img_url = URL.createObjectURL(file.raw);

      },



      // 关闭方法
      closeDialog() {


        this.submit_data.driver_code = '';
        this.submit_data.name = '';
        this.submit_data.phone = '';
        this.submit_data.address = '';
        this.submit_data.sex = '';

        this.submit_data.capacity = '';

        this.submit_data.level = '';
        this.submit_data.status = '';
        this.submit_data.urgent_name = '';
        this.submit_data.urgent_phone = '';
        this.submit_data.logo_img_hash = '';
        this.submit_data.remarks = '';
        this.submit_data.system_remarks = '';
        this.submit_data.city_group_code = '';
        this.submit_data.activite_sum = '';
        this.submit_data.driver_or_legwork=''
        console.log(this.submit_data);
        _this.img_url.logo_img_url = '';

        _this.$emit('closeDialog');
      },

      beforeSubmit(){
        console.log(_this.form.balance>0);
        console.log(_this.form.bond>0);
        console.log(_this.form.insurance>0);
        if(_this.form.balance>0 || _this.form.bond>0 || _this.form.insurance>0){

          this.$confirm(`当前司机押金${_this.form.bond}元,余额${_this.form.balance}元,服务费${_this.form.insurance}元`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            //确定事件

            _this.basicsonSubmit()

          }).catch(() => {
            //取消事件


          });

        }else{
          _this.basicsonSubmit()
        }

      },

      // 基础信息提交
      basicsonSubmit() {







        console.log(_this.submit_data);
        _this.$post(
            "/driver/editDriverSubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发driver组件自定义事件刷新表格
            bus.$emit('onSubmit');
            _this.closeDialog();

            _this.$message.success({
              message: res.msg,
              duration: 1500
            });
          }).catch(res => {

          })
      },



      // 图片压缩方法
      dataURItoBlob(dataURI, type) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
          type: type
        });
      },


      // 图片上传之前执行的函数
      beforeAvatarUpload(file) {

        // 添加请求头
        _this.img_headers.token = localStorage.getItem(config.localStorage_token_name);
        _this.img_headers['hash-key'] = _this.$hash_key();


        return new Promise(resolve => {
          const reader = new FileReader();
          const image = new Image();
          image.onload = (imageEvent) => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const width = image.width * _this.imgQuality;
            const height = image.height * _this.imgQuality;
            canvas.width = width;
            canvas.height = height;
            context.clearRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            const dataUrl = canvas.toDataURL(file.type);
            const blobData = _this.dataURItoBlob(dataUrl, file.type);
            resolve(blobData)
          }
          reader.onload = (e => {
            image.src = e.target.result;
          });
          reader.readAsDataURL(file);
        })
      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

</style>
